module.exports = __webpack_public_path__ + "static/uni_sorenson-a133f008af16081566c7e21d94011af6.png";